import React from "react";
import styled from "styled-components";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";
import SimpleButton from "../../Buttons/SimpleButton.js";
import { Link } from "react-router-dom";

import ConsultantOne from "../../Global/images/imageColaborador1.png";
import ConsultantTwo from "../../Global/images/imageColaborador2.png";
import ConsultantThree from "../../Global/images/imageColaborador3.png";
import ConsultantFour from "../../Global/images/imageColaborador4.png";
import ConsultantFive from "../../Global/images/Team_06.png";
import ConsultantSix from "../../Global/images/Team_07.png";
import ConsultantSeven from "../../Global/images/Team_08.png";
import ConsultantEight from "../../Global/images/Team_02.png";

const StyledLinkedinBlock = styled(NanoFlex)`
  border-radius: 10px;
  overflow: hidden;
  height: auto;
  padding: 0 100px;
  gap: 46px;

  .leftContentBlock {
    height: auto;
    gap: 36px;
    width: 22%;

    .leftBlockTitle {
      height: auto;

      h2 {
        font-weight: 500;
      }
    }

    .leftBlockText {
      height: auto;

      p {
        font-weight: 500;
        color: ${(props) => props.theme.color.primaryColors.secFontColor};
      }
    }
  }

  .rightContentBlock {
    width: 70%;
    gap: 32px;
    padding: 0 0 0 17vw;
    position: relative;
    overflow: hidden;

    .consultantsSliding {
      width: max-content;
      min-width: 100%;
      gap: 32px;

      &::before {
        content: "";
        z-index: 5;
        left: 0;
        position: absolute;
        height: calc(100% + 10px);
        width: 17vw;
        background: white;
      }
    }

    .consultantBlock {
      height: 560px;
      overflow: hidden;
      position: relative;
      border-radius: 10px;
      min-width: calc(25% - 24px);
      animation: linkedInSlider 90s ease-in-out infinite;

      .backgroundImage {
        position: absolute;
        min-height: 100%;
        min-width: 100%;
        height: 100%;
        width: auto;
        overflow: hidden;
        user-select: none;

        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
          object-position: top;
          user-select: none;
        }
      }

      .consultantName {
        position: absolute;
        padding: 10px 24px;
        background-color: ${(props) => props.theme.color.primaryColors.mediumPurple};
        z-index: 3;
        height: auto;
        border-radius: 0 20px 20px 0;
        left: 0;
        width: auto;
        bottom: 20px;
        p {
          color: ${(props) => props.theme.color.primaryColors.darkPurple};
        }
      }
    }
  }

  @keyframes linkedInSlider {
    from {
      left: 0;
    }

    to {
      left: calc(-300% - 96px);
    }
  }

  /* SMALL DESKTOPS */
  @media only screen and (max-width: 1450px) {
    padding: 0 50px;

    .leftContentBlock {
      width: 27%;
    }

    .rightContentBlock {
      .consultantBlock {
        height: 450px;

        .consultantName {
          padding: 5px 16px;
        }
      }
    }
  }

  /* TABLETS */
  @media only screen and (max-width: 1024px) {
    padding: 0px 30px;

    .rightContentBlock {
      gap: 16px;
      padding: 0 0 0 5vw;

      .consultantBlock {
        height: 400px;
        min-width: calc(33.33% - 16px);
        .consultantName {
          display: none;
        }
      }

      .consultantsSliding {
        &::before {
          width: 5vw;
        }

        .consultantBlock {
          animation: linkedInSlider 70s ease-in-out infinite;
        }
      }
    }
  }

  /* MOBILE */
  @media only screen and (max-width: 815px) {
    padding: 0px 20px;

    .rightContentBlock {
      .consultantsSliding {
        gap: 16px;

        .consultantBlock {
          min-width: calc(33.33% - 16px);
          animation: linkedInSlider 80s ease-in-out infinite;
        }
      }
    }

    @keyframes linkedInSlider {
      from {
        left: 0;
      }

      to {
        left: calc(-300% - 552px);
      }
    }
  }

  /* MOBILE MEDIUM*/
  @media only screen and (max-width: 650px) {
    .leftContentBlock {
      width: 100%;
      gap: 24px;

      .leftBlockTitle {
        text-align: center;
        justify-content: center;
      }

      .leftBlockText {
        text-align: center;
        justify-content: center;
      }
      a {
        width: 100%;
        .button {
          width: 100%;
          button {
            justify-content: center;
          }
        }
      }
    }
    .rightContentBlock {
      display: none;
    }
  }

  /* MOBILE SMALL*/
  @media only screen and (max-width: 390px) {
    padding: 0;
  }
`;

export default class LinkedinBlock extends BaseComponent {
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }
  render() {
    return (
      <StyledLinkedinBlock className="linkedinBlock" justifyContent="space-between">
        <NanoFlex className="leftContentBlock" flexDirection="column" alignItems="flex-start">
          <NanoFlex className="leftBlockTitle" justifyContent="flex-start">
            <Type.h2>{this.translation.global.linkedinBlock.weAreInLinkedIn}</Type.h2>
          </NanoFlex>
          <NanoFlex className="leftBlockText" justifyContent="flex-start">
            <Type.p>{this.translation.global.linkedinBlock.linkedinFindUs}</Type.p>
          </NanoFlex>
          <Link to="/recrutamento">
            <SimpleButton darkPurple label={this.translation.global.linkedinBlock.findOffers} />
          </Link>
        </NanoFlex>
        <NanoFlex className="rightContentBlock" justifyContent="flex-end">
          <NanoFlex className="consultantsSliding" justifyContent="flex-start">
            <NanoFlex className="consultantBlock">
              <NanoFlex className="backgroundImage" justifyContent="flex-start">
                <img src={ConsultantOne} />
              </NanoFlex>
              <NanoFlex className="consultantName">
                <Type.p>Diana</Type.p>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="consultantBlock">
              <NanoFlex className="backgroundImage" justifyContent="flex-start">
                <img src={ConsultantTwo} />
              </NanoFlex>
              <NanoFlex className="consultantName">
                <Type.p>Carolina</Type.p>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="consultantBlock">
              <NanoFlex className="backgroundImage" justifyContent="flex-start">
                <img src={ConsultantThree} />
              </NanoFlex>
              <NanoFlex className="consultantName">
                <Type.p>Juliana</Type.p>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="consultantBlock">
              <NanoFlex className="backgroundImage" justifyContent="flex-start">
                <img src={ConsultantFour} />
              </NanoFlex>
              <NanoFlex className="consultantName">
                <Type.p>Beatriz</Type.p>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="consultantBlock">
              <NanoFlex className="backgroundImage" justifyContent="flex-start">
                <img src={ConsultantFive} />
              </NanoFlex>
              <NanoFlex className="consultantName">
                <Type.p>César</Type.p>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="consultantBlock">
              <NanoFlex className="backgroundImage" justifyContent="flex-start">
                <img src={ConsultantSix} />
              </NanoFlex>
              <NanoFlex className="consultantName">
                <Type.p>Joana</Type.p>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="consultantBlock">
              <NanoFlex className="backgroundImage" justifyContent="flex-start">
                <img src={ConsultantSeven} />
              </NanoFlex>
              <NanoFlex className="consultantName">
                <Type.p>Teresa</Type.p>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="consultantBlock">
              <NanoFlex className="backgroundImage" justifyContent="flex-start">
                <img src={ConsultantEight} />
              </NanoFlex>
              <NanoFlex className="consultantName">
                <Type.p>Catarina</Type.p>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="consultantBlock">
              <NanoFlex className="backgroundImage" justifyContent="flex-start">
                <img src={ConsultantOne} />
              </NanoFlex>
              <NanoFlex className="consultantName">
                <Type.p>Diana</Type.p>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="consultantBlock">
              <NanoFlex className="backgroundImage" justifyContent="flex-start">
                <img src={ConsultantTwo} />
              </NanoFlex>
              <NanoFlex className="consultantName">
                <Type.p>Carolina</Type.p>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="consultantBlock">
              <NanoFlex className="backgroundImage" justifyContent="flex-start">
                <img src={ConsultantThree} />
              </NanoFlex>
              <NanoFlex className="consultantName">
                <Type.p>Juliana</Type.p>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="consultantBlock">
              <NanoFlex className="backgroundImage" justifyContent="flex-start">
                <img src={ConsultantFour} />
              </NanoFlex>
              <NanoFlex className="consultantName">
                <Type.p>Beatriz</Type.p>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="consultantBlock">
              <NanoFlex className="backgroundImage" justifyContent="flex-start">
                <img src={ConsultantFive} />
              </NanoFlex>
              <NanoFlex className="consultantName">
                <Type.p>César</Type.p>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="consultantBlock">
              <NanoFlex className="backgroundImage" justifyContent="flex-start">
                <img src={ConsultantSix} />
              </NanoFlex>
              <NanoFlex className="consultantName">
                <Type.p>Joana</Type.p>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="consultantBlock">
              <NanoFlex className="backgroundImage" justifyContent="flex-start">
                <img src={ConsultantSeven} />
              </NanoFlex>
              <NanoFlex className="consultantName">
                <Type.p>Teresa</Type.p>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="consultantBlock">
              <NanoFlex className="backgroundImage" justifyContent="flex-start">
                <img src={ConsultantEight} />
              </NanoFlex>
              <NanoFlex className="consultantName">
                <Type.p>Catarina</Type.p>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
      </StyledLinkedinBlock>
    );
  }
}
